var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57512 13.7212C8.5496 13.7212 10.1502 15.3609 10.1502 17.3606C10.1502 19.3602 8.5496 21 6.57512 21C4.60063 21 3 19.3602 3 17.3606C3 15.3609 4.60063 13.7212 6.57512 13.7212Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57512 3C8.5496 3 10.1502 4.63976 10.1502 6.63942C10.1502 8.63909 8.5496 10.2788 6.57512 10.2788C4.60063 10.2788 3 8.63909 3 6.63942C3 4.63976 4.60063 3 6.57512 3Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4249 13.7212C19.3994 13.7212 21 15.3609 21 17.3606C21 19.3602 19.3994 21 17.4249 21C15.4504 21 13.8498 19.3602 13.8498 17.3606C13.8498 15.3609 15.4504 13.7212 17.4249 13.7212Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4249 3C19.3994 3 21 4.63976 21 6.63942C21 8.63909 19.3994 10.2788 17.4249 10.2788C15.4504 10.2788 13.8498 8.63909 13.8498 6.63942C13.8498 4.63976 15.4504 3 17.4249 3Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsOn);
export default __webpack_public_path__ + "static/media/dots_on.65db571ce567655bfef8b00edf8bcce7.svg";
export { ForwardRef as ReactComponent };